import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { Flex } from '../flex';
import { theme } from '../theme';
import { BodyText, Label } from '../typography';

export const StyledInfoRowWrapper = styled(Flex)`
  flex-direction: row;
  align-items: stretch;
`;

export const StyledInfoName = styled.div`
  width: 16.813rem;
  min-width: 7.313rem;

  padding-top: 1.563rem;
  padding-bottom: 1.563rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: ${({theme}) => theme.colors.primaryK8};

  ${Label} {
    padding-right: 0.625rem;
    margin-bottom: 0;
    padding-left: 0.5rem;
    text-align: right;
  }

  ${mediaQuery('md')} {
    min-width: 16.813rem;
  }
`;

export const StyledInfoItem = styled.div`
  width: 100%;
  padding-top: 1.281rem;
  padding-bottom: 1.281rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.primaryK1};
  margin-left: 2.5rem;

  ${BodyText} {
    padding-left: 0.625rem;
    margin-bottom: 0;
  }
`;
